export const useSite = () => useNuxtApp().$site.site

export const useTheme = () => useNuxtApp().$site.theme
